/* NgRx */
import {createAction, props} from "@ngrx/store";
import {ProfileModel} from "../../../models/profile.model";
import {UpdatePasswordModel} from "../models/update-password.model";
import {GenerateUsername} from "../models/generate-username";
import {VerifyUsername} from "../models/verify-username";
import {GenerateOtpModel} from "../../authentication/models/generate-otp.model";
import {VerifyOtpModel} from "../../authentication/models/verify-otp.model";
import {Filter} from "../../../models/filter";
import {
  NotificationItemModel
} from "../../page-modules/notifications/model/notification-model";


/******** LOADING ***********/
const START_LOADING = '[shared] start loading';
export const StartLoading = createAction(START_LOADING);

const STOP_LOADING = '[shared] stop loading';
export const StopLoading = createAction(STOP_LOADING);

const CLEAR_LOADING = '[shared] clear loading';
export const ClearLoading = createAction(CLEAR_LOADING);

/******** CLEAR STATE ***********/
const CLEAR_STATE = "[shared] clear state";
export const ClearState = createAction(CLEAR_STATE);

/******** CLEAR SELECTED USER DATA ***********/
const CLEAR_SELECTED_USER_DATA = "[shared] clear selected user data";
export const ClearSelectedUserData = createAction(CLEAR_SELECTED_USER_DATA);

/******** SET SCREEN TYPE ***********/
const SET_SCREEN_TYPE = "[shared] set screen type";
export const SetScreenType = createAction(SET_SCREEN_TYPE, props<{
  screenType: "mobile" | "tablet" | "desktop" | ""
}>());

/******** SET SCREEN SIZE ***********/
const SET_SCREEN_SIZE = "[shared] set screen size";
export const SetScreenSize = createAction(SET_SCREEN_SIZE, props<{
  screenSize: "xs" | "sm" | "md" | "lg" | "xl" | ""
}>());

/******** SET PROFILE ***********/
const SET_PROFILE = "[shared] set profile";
export const SetProfile = createAction(SET_PROFILE, props<{ profile: ProfileModel }>());

/******** SET DRILL DOWN URLS ***********/
const SET_DRILL_DOWN_URLS = "[shared] set drill down urls";
export const SetDrillDownUrls = createAction(SET_DRILL_DOWN_URLS, props<{ payload: string[] }>());

/******** FETCH PROFILE ***********/
const FETCH_PROFILE_REQUEST = "[shared] fetch profile requested";
export const FetchProfileRequest = createAction(FETCH_PROFILE_REQUEST);

const FETCH_PROFILE_SUCCESS = "[shared] fetch profile successful";
export const FetchProfileSuccess = createAction(FETCH_PROFILE_SUCCESS, props<{
  profile: ProfileModel,
  message: string
}>());

const FETCH_PROFILE_FAILURE: string = "[shared] fetch profile failure";
export const FetchProfileFailure = createAction(FETCH_PROFILE_FAILURE);

/******** FETCH PROFILE BY USER ID ***********/
const FETCH_PROFILE_BY_USER_ID_REQUEST = "[shared] fetch profile by user id requested";
export const FetchProfileByUserIdRequest = createAction(
  FETCH_PROFILE_BY_USER_ID_REQUEST,
  props<{ payload: { userId: number } }>()
);

const FETCH_PROFILE_BY_USER_ID_SUCCESS = "[shared] fetch profile by user id successful";
export const FetchProfileByUserIdSuccess = createAction(
  FETCH_PROFILE_BY_USER_ID_SUCCESS,
  props<{
    profile: ProfileModel,
    message: string
  }>()
);

const FETCH_PROFILE_BY_USER_ID_FAILURE = "[shared] fetch profile by user id failure";
export const FetchProfileByUserIdFailure = createAction(FETCH_PROFILE_BY_USER_ID_FAILURE);

/******** EDIT PROFILE ***********/
const EDIT_PROFILE_REQUEST = "[shared] edit profile requested";
export const EditProfileRequest = createAction(EDIT_PROFILE_REQUEST, props<any>());

const EDIT_PROFILE_SUCCESS = "[shared] edit profile successful";
export const EditProfileSuccess = createAction(EDIT_PROFILE_SUCCESS, props<any>());

const EDIT_PROFILE_FAILURE = "[shared] edit profile failure";
export const EditProfileFailure = createAction(EDIT_PROFILE_FAILURE);

/******** EDIT PROFILE BY USERID ***********/
const EDIT_PROFILE_BY_USER_ID_REQUEST = "[shared] edit profile by user id requested";
export const EditProfileByUserIdRequest = createAction(EDIT_PROFILE_BY_USER_ID_REQUEST, props<any>());

const EDIT_PROFILE_BY_USER_ID_SUCCESS = "[shared] edit profile by user id successful";
export const EditProfileByUserIdSuccess = createAction(EDIT_PROFILE_BY_USER_ID_SUCCESS, props<any>());

const EDIT_PROFILE_BY_USER_ID_FAILURE = "[shared] edit profile by user id failure";
export const EditProfileByUserIdFailure = createAction(EDIT_PROFILE_BY_USER_ID_FAILURE);

/*********** FETCH GENDER FILTER **************/
const FETCH_GENDER_FILTER_REQUEST = "[shared] fetch gender filter requested";
export const FetchGenderFilterRequest = createAction(FETCH_GENDER_FILTER_REQUEST);

const FETCH_GENDER_FILTER_SUCCESS = "[shared] fetch gender filter successful";
export const FetchGenderFilterSuccess = createAction(FETCH_GENDER_FILTER_SUCCESS, props<{
  genderList: Filter,
  message: string
}>());

const FETCH_GENDER_FILTER_FAILURE = "[shared] fetch gender filter failure";
export const FetchGenderFilterFailure = createAction(FETCH_GENDER_FILTER_FAILURE, props<{
  message: string
}>());

/******** UPDATE PASSWORD ***********/
const UPDATE_PASSWORD_REQUEST = "[shared] update password requested";
export const UpdatePasswordRequest = createAction(UPDATE_PASSWORD_REQUEST, props<{
  payload: UpdatePasswordModel["request"]
}>());

const UPDATE_PASSWORD_SUCCESS = "[shared] update password successful";
export const UpdatePasswordSuccess = createAction(UPDATE_PASSWORD_SUCCESS, props<{ message: string }>());

const UPDATE_PASSWORD_FAILURE = "[shared] update password failure";
export const UpdatePasswordFailure = createAction(UPDATE_PASSWORD_FAILURE, props<{ error: any }>());

/******** AUTO GENERATE USERNAME ***********/

const GENERATE_USERNAME_REQUEST = "[shared] auto generate username requested";
export const GenerateUsernameRequest = createAction(GENERATE_USERNAME_REQUEST, props<{
  payload: GenerateUsername["request"]
}>());

const GENERATE_USERNAME_SUCCESS = "[shared] auto generate username successful";
export const GenerateUsernameSuccess = createAction(GENERATE_USERNAME_SUCCESS, props<GenerateUsername["response"]["data"]>());

const GENERATE_USERNAME_FAILURE = "[shared] auto generate username failure";
export const GenerateUsernameFailure = createAction(GENERATE_USERNAME_FAILURE);

/******** CLEAR AUTO GENERATED USERNAME ***********/

const CLEAR_AUTO_GENERATED_USERNAME = "[shared] clear auto generated username";
export const ClearAutoGeneratedUsername = createAction(CLEAR_AUTO_GENERATED_USERNAME);

/******** VERIFY USERNAME ***********/

const VERIFY_USERNAME_REQUEST = "[shared] verify username requested";
export const VerifyUsernameRequest = createAction(VERIFY_USERNAME_REQUEST, props<{
  payload: VerifyUsername["request"]
}>());
const VERIFY_USERNAME_SUCCESS = "[shared] verify username successful";
export const VerifyUsernameSuccess = createAction(VERIFY_USERNAME_SUCCESS, props<VerifyUsername["response"]["data"]>());

const VERIFY_USERNAME_FAILURE = "[shared] verify username failure";
export const VerifyUsernameFailure = createAction(VERIFY_USERNAME_FAILURE);

/*********** SAVE ANSWERS **************/
const SAVE_ANSWERS_REQUEST = "[shared] save answers requested";
export const SaveAnswersRequest = createAction(SAVE_ANSWERS_REQUEST, props<any>());

const SAVE_ANSWERS_SUCCESS = "[shared] save answers successful";
export const SaveAnswersSuccess = createAction(SAVE_ANSWERS_SUCCESS, props<any>());

const SAVE_ANSWERS_FAILURE = "[shared] save answers failure";
export const SaveAnswersFailure = createAction(SAVE_ANSWERS_FAILURE);

/*********** GENERATE OTP **************/
const GENERATE_OTP_REQUEST = "[shared] generate otp requested";
export const GenerateOtpRequest = createAction(GENERATE_OTP_REQUEST, props<{ payload: GenerateOtpModel["request"] }>());

const GENERATE_OTP_SUCCESS = "[shared] generate otp successful";
export const GenerateOtpSuccess = createAction(GENERATE_OTP_SUCCESS, props<{ message: string }>());

const GENERATE_OTP_FAILURE = "[shared] generate otp failure";
export const GenerateOtpFailure = createAction(GENERATE_OTP_FAILURE, props<{ message: string }>());

/*********** VERIFY OTP **************/
const VERIFY_OTP_REQUEST = "[shared] verify otp requested";
export const VerifyOtpRequest = createAction(VERIFY_OTP_REQUEST, props<{ payload: VerifyOtpModel["request"] }>());

const VERIFY_OTP_SUCCESS = "[shared] verify otp successful";
export const VerifyOtpSuccess = createAction(VERIFY_OTP_SUCCESS, props<{ message: string }>());

const VERIFY_OTP_FAILURE = "[shared] verify otp failure";
export const VerifyOtpFailure = createAction(VERIFY_OTP_FAILURE, props<{ message: string }>());

/*********** OTP SENT STATUS **************/
const OTP_SENT_STATUS = "[shared] otp sent status";
export const OtpSentStatus = createAction(OTP_SENT_STATUS, props<{
  otpSent: boolean
}>());


/*********** Fetch Notification Details **************/
const FETCH_NOTIFICATION_DETAILS_REQUEST = '[shared] fetch notification details request'
export const FetchNotificationDetailsRequest = createAction(FETCH_NOTIFICATION_DETAILS_REQUEST, props<{ payload: { notificationId: string } }>())

const FETCH_NOTIFICATION_DETAILS_SUCCESS = '[shared] fetch notification details success'
export const FetchNotificationDetailsSuccess = createAction(FETCH_NOTIFICATION_DETAILS_SUCCESS, props<{ payload: { notificationDetails: NotificationItemModel } }>())

const FETCH_NOTIFICATION_DETAILS_FAILURE = '[shared] fetch notification details failure'
export const FetchNotificationDetailsFailure = createAction(FETCH_NOTIFICATION_DETAILS_FAILURE,)


/*********** Mark Notification Read **************/

const MARK_NOTIFICATION_AS_READ_REQUEST = '[shared] mark notification as read request';
export const MarkNotificationAsReadRequest = createAction(MARK_NOTIFICATION_AS_READ_REQUEST, props<{ payload: { notificationId: string[], } }>())

const MARK_NOTIFICATION_AS_READ_SUCCESS = '[shared] mark notification as read success';
export const MarkNotificationAsReadSuccess = createAction(MARK_NOTIFICATION_AS_READ_SUCCESS)

const MARK_NOTIFICATION_AS_READ_FAILURE = '[shared] mark notification as read success';
export const MarkNotificationAsReadFailure = createAction(MARK_NOTIFICATION_AS_READ_FAILURE)

/*********** Fetch Notification for the popup **************/
const FETCH_LATEST_NOTIFICATION_FOR_POPUP_REQUEST = '[shared] fetch latest notification for popup request'
export const FetchLatestNotificationForPopupRequest = createAction(FETCH_LATEST_NOTIFICATION_FOR_POPUP_REQUEST, props<{ payload: { timestamp?: any } }>())


const FETCH_LATEST_NOTIFICATION_FOR_POPUP_SUCCESS = '[shared] fetch latest notification for popup success'
export const FetchLatestNotificationForPopupSuccess = createAction(FETCH_LATEST_NOTIFICATION_FOR_POPUP_SUCCESS, props<{
  payload: {
    currentTimestamp: any
  }
}>())

const FETCH_LATEST_NOTIFICATION_FOR_POPUP_FAILURE = '[shared] fetch latest notification for popup failure'
export const FetchLatestNotificationForPopupFailure = createAction(FETCH_LATEST_NOTIFICATION_FOR_POPUP_FAILURE)

/*********** Trigger Notification **************/

const TRIGGER_NOTIFICATION_REQUEST = '[shared] trigger notification request';
export const TriggerNotificationRequest = createAction(TRIGGER_NOTIFICATION_REQUEST, props<{ payload: { type?: number, userId?: number, surveyId?: number } }>());

const TRIGGER_NOTIFICATION_SUCCESS = '[shared] trigger notification success';
export const TriggerNotificationSuccess = createAction(TRIGGER_NOTIFICATION_SUCCESS, props<{ payload: { message: string } }>());

const TRIGGER_NOTIFICATION_FAILURE = '[shared] trigger notification failure';
export const TriggerNotificationFailure = createAction(TRIGGER_NOTIFICATION_FAILURE);

/*********** FETCH USER STATUS FILTER **************/
const FETCH_USER_STATUS_FILTER_REQUEST = "[shared] fetch user status filter requested";
export const FetchUserStatusFilterRequest = createAction(FETCH_USER_STATUS_FILTER_REQUEST);

const FETCH_USER_STATUS_FILTER_SUCCESS = "[shared] fetch user status filter successful";
export const FetchUserStatusFilterSuccess = createAction(FETCH_USER_STATUS_FILTER_SUCCESS, props<{
  userStatusList: Filter,
  message: string
}>());

const FETCH_USER_STATUS_FILTER_FAILURE = "[shared] fetch user status filter failure";
export const FetchUserStatusFilterFailure = createAction(FETCH_USER_STATUS_FILTER_FAILURE, props<{
  message: string
}>());

/*********** Delete Notification **************/
const DELETE_NOTIFICATION_REQUEST = '[shared] delete notification request'
export const DeleteNotificationRequest = createAction(DELETE_NOTIFICATION_REQUEST, props<{
  payload: { notificationId: string[] }
}>());

const DELETE_NOTIFICATION_SUCCESS = '[shared] delete notification success'
export const DeleteNotificationSuccess = createAction(DELETE_NOTIFICATION_SUCCESS, props<{ payload: { message: string } }>())

const DELETE_NOTIFICATION_FAILURE = '[shared] delete notification failure'
export const DeleteNotificationFailure = createAction(DELETE_NOTIFICATION_FAILURE)

/******** SET WEEK INFO FOR CONTRACT ***********/
const SET_WEEK_INFO_FOR_CONTRACT = '[shared] set week info for contract';
export const SetWeekInfoForContract = createAction(SET_WEEK_INFO_FOR_CONTRACT, props<{
  weekNumber: number,
  weekStartDate: string,
  weekEndDate: string,
  previousUrl: string,
  sessionNumber: number
}>());

/******** CLEAR WEEK INFO FOR CONTRACT ***********/
const CLEAR_WEEK_INFO_FOR_CONTRACT = '[shared] clear week info for contract';
export const ClearWeekInfoForContract = createAction(CLEAR_WEEK_INFO_FOR_CONTRACT);

/******** UPDATE ACTIVE GROUP DETAILS ON PROFILE ***********/
const UPDATE_ACTIVE_GROUP_DETAILS_ON_PROFILE = '[shared] update active group' +
                                               ' details on profile';
export const UpdateActiveGroupDetailsOnProfile = createAction(UPDATE_ACTIVE_GROUP_DETAILS_ON_PROFILE, props<{
  groupId: number | null,
  groupName: string | null,
  groupStart: string | null,
  groupStarted: boolean | null
}>());

/*********** DELETE USER **************/
const DELETE_USER_REQUEST = '[shared] delete user name' +
                            ' requested';
export const DeleteUserRequest = createAction(DELETE_USER_REQUEST, props<any>());

const DELETE_USER_SUCCESS = '[shared] delete user successful';
export const DeleteUserSuccess = createAction(DELETE_USER_SUCCESS, props<{
  message: string
}>());

const DELETE_USER_FAILURE = '[shared] delete user failure';
export const DeleteUserFailure = createAction(DELETE_USER_FAILURE);

/*********** FETCH AVATAR FILTER **************/
const FETCH_AVATAR_FILTER_REQUEST = '[shared] fetch avatar filter requested';
export const FetchAvatarFilterRequest = createAction(FETCH_AVATAR_FILTER_REQUEST);

const FETCH_AVATAR_FILTER_SUCCESS = '[shared] fetch avatar filter successful';
export const FetchAvatarFilterSuccess = createAction(FETCH_AVATAR_FILTER_SUCCESS, props<{
  avatarOptions: any,
  message: string
}>());

const FETCH_AVATAR_FILTER_FAILURE = '[shared] fetch avatar filter failure';
export const FetchAvatarFilterFailure = createAction(FETCH_AVATAR_FILTER_FAILURE);
